<template>
  <v-dialog
    v-model="isVisible"
    persistent
    scrollable
  >
    <v-card ref="legalCaseEditorNewPartyDialogCard">
      <v-toolbar
        color="secondary"
        dark
        tile
      >
        <v-toolbar-title>
          Add a new party
        </v-toolbar-title>

        <v-spacer />

        <v-btn
          icon
          @click="_ => onCloseDialog()"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-5">
        <v-row>
          <v-col>
            <PartyFields
              :party="party"
              required
              @update="party => updateParty(party)"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn
          text
          @click="_ => onCloseDialog()"
        >
          Cancel
        </v-btn>

        <v-spacer />

        <v-btn
          :disabled="!isValid"
          text
          @click="_ => save()"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { isEmpty } from 'lodash'
import { useVuelidate } from '@vuelidate/core'

import { filterValidParties } from '@/utilities/party'

import PartyFields from './LegalCaseEditorPartyFields.vue'

export default {
  name: 'LegalCaseEditorPartyFieldsDialog',

  components: {
    PartyFields,
  },

  model: {
    prop: 'visible',
    event: 'change',
  },

  props: {
    party: {
      default: _ => ({}),
      type: Object,
    },

    visible: {
      required: true,
      type: Boolean,
    },
  },

  setup () {
    return {
      $v: useVuelidate(),
    }
  },

  data () {
    return {
      editedParty: {},
    }
  },

  computed: {
    isValid () {
      return this.editedParty && !isEmpty(filterValidParties([this.editedParty])) && !this.$v.$invalid
    },

    isVisible: {
      get () { return this.visible },
      set (value) { this.$emit('change', value === true) },
    },
  },

  methods: {
    onCloseDialog () {
      this.isVisible = false
    },

    partyHasEmail () {
      return this.editedParty.email?.no_email || this.editedParty.email?.address
    },

    partyHasPhone () {
      return this.editedParty.phone?.phone_number
    },

    save () {
      if (!this.isValid) return

      this.$emit('save', this.editedParty)
      this.onCloseDialog()
    },

    updateParty (party) {
      if (!party.email?.no_email && !isEmpty(party.email?.address)) party.email.primary = true

      if (!isEmpty(party.phone?.phone_number)) {
        // TODO: Check if there is some guard clause to add as the user can select
        // amongst all know phone types, however there are some types that are not
        // compatible with the current workflow and requirements, e.g. 'Voice only'
        // breaks the intent of sending something via text to the party.
        party.phone.preferred_text = true
        party.phone.preferred_voice = true
      }

      this.editedParty = {
        ...party,
        primary_email: party.email,
        primary_text_number: party.phone,
      }
    },
  },
}
</script>
